import { Snippet } from '@distribute/shared/types';
import { Icon } from '../../../shared/ui';
import { FC } from 'react';

import { snippetItemIconByType } from '../config';

type Props = {
  snippet: Snippet;
};

export const SnippetCardRowPreview: FC<Props> = ({ snippet }) => {
  return (
    <div className="flex flex-nowrap items-center gap-x-3 min-w-0">
      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-100 border border-base-black/[0.04] flex-shrink-0">
        <Icon
          glyph={snippetItemIconByType[snippet.type]}
          width={20}
          className="text-gray-600 flex-shrink-0"
        />
      </div>
      <p className="text-md font-semibold text-gray-900 truncate">
        {snippet.name || 'Untitled'}
      </p>
    </div>
  );
};
